<template>
  <div class="flex flex-col justify-between w-full pb-3">
    <template v-if="$mq === 'sm'">
      <contact-cell
        :contact="contact"
        :key="`contact_${i}`"
        v-for="(contact, i) in contacts"
      />
    </template>
    <bdg-table-view :rows="contacts" :columns="columns">
      <template #beside-pagination v-if="userType === UserTypes.ADMIN">
        <bdg-button
          class="ghost has-icon w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square"
          @click.native="addContact"
        >
          add contact
        </bdg-button>
      </template>
    </bdg-table-view>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
import BdgTableView from "../../elements/table-view/BdgTableView";
import ContactCell from "../../elements/list-view/list-view-cells/contract-cells/ContactCell";
import IconTextCell from "../../elements/table-view/special-cells/IconTextCell";
import ContractContactForm from "./forms/ContractContactForm";
import GenericDeleteModal from "../../components/modals/GenericDeleteModal";
import {
  ContactTypes,
  InternalSubtypeLabels,
  VendorSubtypeLabels
} from "../../constants/contact-enums";
import { PartnerSubtypeIcons } from "../../js-data/icon-maps";
import { UserTypes } from "../../constants/user-enums";
import EmailCell from "../../elements/table-view/special-cells/EmailCell";
import CompanyAndContactNamesCell from "../../elements/table-view/special-cells/CompanyAndContactNamesCell";
import { sortContacts } from "../../helpers";

export default {
  name: "ContractContacts",
  components: { ContactCell, BdgTableView, BdgButton },
  data() {
    return {
      UserTypes
    };
  },
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    contract() {
      return this.$store.state.Contracts.contract;
    },
    columns() {
      const columns = [
        {
          label: "name",
          property: "companyAndContactNames",
          cellComponent: CompanyAndContactNamesCell
        },
        {
          label: "Type",
          property: "type",
          additionalCellClasses: "capitalize"
        },
        {
          label: "Subtype",
          property: "subtypeWithIcon",
          cellComponent: IconTextCell,
          additionalCellClasses: "text-sm"
        },
        { label: "Email", property: "nestedEmail", cellComponent: EmailCell },
        { label: "Phone", property: "primaryPhoneDisplayString" },
        {
          label: "Actions",
          property: "actions",
          actions: [
            {
              label: "edit",
              clickAction: contact => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: ContractContactForm,
                  createEditComponentData: {
                    ...contact,
                    contract: this.contract
                  },
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: contact => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "contact",
                    deleteFunction: () =>
                      this.$store.dispatch("dissociateContactFromContract", {
                        contactId: contact.id,
                        contractId: parseInt(this.$route.params.id, 10)
                      })
                  },
                  isShown: true
                });
              }
            }
          ],
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ];

      if (this.userType === UserTypes.ADMIN) {
        return columns;
      }
      return columns.filter(col => col.property !== "actions");
    },
    contacts() {
      if (this.contract) {
        const contacts = this.contract.additional_contacts;
        if (contacts) {
          return contacts.sort(sortContacts).map(contact => {
            if (contact.subtype) {
              const labelEnum =
                contact.type === ContactTypes.INTERNAL
                  ? InternalSubtypeLabels
                  : VendorSubtypeLabels;
              contact.subtypeWithIcon = {
                iconClasses:
                  contact.type === ContactTypes.PARTNER
                    ? `${PartnerSubtypeIcons[contact.subtype]} text-blue`
                    : "",
                text: labelEnum[contact.subtype].toUpperCase()
              };
            }

            contact.nestedEmail = { email: contact.email };

            contact.companyAndContactNames = {
              companyName: contact.company_name,
              name: contact.name
            };

            return contact;
          });
        }
      }
      return [];
    }
  },
  methods: {
    addContact() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ContractContactForm,
        createEditComponentData: {
          contract: this.contract
        },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style scoped></style>
